export default "__VITE_ASSET__b682e758__"